import React from 'react'

const ShopViewItems = () => {
    return (
        <div>ShopViewItems</div>
    )
}

export default ShopViewItems